module.exports = __webpack_public_path__ + "img/img13.aa4a4d67.png";